import React, { 

    useState, 
    useEffect, 
    useRef 

} from 'react';



import { 
    useSelector, 
    //useDispatch 
} 
from 'react-redux';
//import { ModifyZoneStore } from 'app-store/actions/ModifyZoneStore';


import {
    //BrowserRouter as Router,
    //Switch,
    //Route,
    //Link,

    //useRouteMatch,
    useLocation,
    //useHistory,   
    //useParams,


} from "react-router-dom";


// import { useWindowDimensions } from 'utils/hooks/WindowDimensionsProvider';
// import useScreenOrientation from 'utils/hooks/ScreenOrientation';
// //import { useFetch }  from 'utils/hooks/Fetch';



import { Area } from 'utils/components/Pages/Styled';
import {

    Container
 
} from 'utils/components/Pages/AuthLogo/SignUpWalk/_Styled';


import FormComponent from 'utils/components/Form';


import FormBuilder from '../Compose/Builder';
import {Cred as FormData} from '../Compose/FormData';



const Index = (props) => {



    const Composed = FormBuilder({array:FormData});


    // // -- window dims -- //
    // const { width, height } = useWindowDimensions();

    // // -- screen orientation -- //
    // const screenOrientation = useScreenOrientation()



    // -- router -- //
    //let params = useParams();
    //let match = useRouteMatch();
    const location = useLocation();
    //const history = useHistory();


    var pathname = location.pathname;

    if(pathname.charAt(0) === '/') 
        pathname = pathname.substring(1,pathname.length);

    if(pathname.charAt(pathname.length-1) === '/') 
        pathname = pathname.substring(0,pathname.length-1);




    // let zoneId;
    // zoneId = pathname.replace(/\//gi,"-");


    // -- redux -- //
    //const dispatch = useDispatch();
    const zoneObj = useSelector(state => state.zone);
    //console.log("zoneObj: "+JSON.stringify(zoneObj, null, 2));



    // let currentZone = pathname;
    // currentZone = currentZone.replace(/\//gi,"-");
    // currentZone = currentZone.replace(/ /gi,"-");

    // //let zoneKey = currentZone + "_fetch";
    

    //------------------------------------------------------------------------------

    const refArea = useRef(null);
    const refContainer = useRef(null);


    // -- state -- //

    const [isLoaded, setIsLoaded] = useState(false);
    //const [databind, setDatabind] = useState(false);
    const [items, setItems] = useState([]);
    const [problemArr, setProblemArr] = useState([]);
    const [border, setBorder] = useState(false);

    useEffect(() => {

        if(!isLoaded)
        {

            //console.log(JSON.stringify(Composed,null,2));

            //alert('!isLoaded');
            setIsLoaded(true);

            if(props.items && props.items !== undefined)
            {
                setItems(props.items);   
            }else{
                setItems(Composed);         
            }

            setProblemArr([]);
            setBorder("0px solid #fff");


        }else{


            if(props.items && props.items !== undefined)
            {
                //console.log("items")
                setItems(props.items);   
            
            }  

        }



    

        // if(!databind)
        // {
        //     setDatabind(props.databind);
        // }


        // if(props.databind.sceneArr.length > 0)
        // {


        //     console.log("AreaEffect --- props.databind.sceneArr: "+JSON.stringify(props.databind.sceneArr,null,2));
  

        // }


    },
    [
        props,
        isLoaded,
        //databind,
        zoneObj,
        Composed

    ])

    




    // const handle = (hndl) => {


    //     alert(hndl.call);


    //     switch(hndl.call)
    //     {
    //     case'makeChoice':

    //     break; 
    //     case'changeSection':

    //     break;
    //     case'submitCreds':

    //     break;
    //     case'submit':

    //     break;
    //     default:
    //     }

    // };







    return (<div>

        <Area
        ref={refArea}
        //backgroundColor={'#191e28'}
        //height={"100vh"}
        >


            <Container
            ref={refContainer} 
            >
                <div className={'Bod'}>

                    <div className={'Heading'}>Email/Password</div>
                    <div className={'Pgraph'}>Please enter login info.</div>
                    <div className={'Pgraph'}>Account ID Example ( rodsrodshop, vitabrew)</div>

                </div>


                {
                props.errorArr.length > 0
                ?
                    <div className={'Err'}>

                        {props.errorArr.map((obj,i) => (

                            <div 
                            key={i}
                            className={'Line'}
                            >

                                {
                                //JSON.stringify(obj)
                                }

                                {obj.message}

                            </div>

                        ))}

                    </div>

                :null
                }


                <div className={'Frm'}>

                    <FormComponent 
                    
                        handleMovement={props.handleMovement}                   
                        handle={props.handle}
                        items={items}
                        problemArr={problemArr}
                        border={border}
            
                    />

                </div>

                <div className={'Bod'}>

                    <div className={'Nav'}>


                        <div className={'NavButton'}


                        // onClick={(v) => props.handle({

                        //     call:"changeSection",
                        //     data:props.sections[parseInt(props.currentSection)+1],
                  
    
                        // })}

                        onClick={(v) => props.handle({

                            call:"submitCred",
                            data:props.sections[parseInt(props.currentSection)+1],
                  
                        })}
                        
                        >

                            Next
                            
                        </div>

                    </div>

                    <div className={'Nav'}>

                        <div className={'NavLink'}
                        onClick={(v) => props.handle({

                            call:"changeSection",
                            data:"",
                            
    
                        })}
                        >
                            {"<< Go Back"}
                            
                        </div>


                    </div>


                </div>

            </Container>


        </Area>

    </div>)


   




}

export default Index;


